export const drawerTypes = {
  filters: 'filters',
  update: 'update',
  create: 'create',
};
